import React, { ChangeEvent, FunctionComponent, useState } from 'react'
import {
  InputContainer,
  InputLabel,
  InputLeadingIcon,
  InputTextField,
  InputTrailingIcon,
} from '../sharedStyle'
import { IProps } from './IProps'

import { InputFieldInput } from './style'

export const LabelInputField: FunctionComponent<IProps> = ({
  fieldLabel,
  fieldColor,
  leadingIcon,
  type,
  min,
  trailingIcon,
  initialValue = '',
  onFocus,
  onBlur,
  placeholder,
  customWidth,
  onChange,
  forceChangeValue,
}) => {
  const [isInputFocus, setIsInputFocus] = useState<boolean>(false)
  const [hasText, setHasText] = useState<string>(initialValue)

  const focusFunction = () => {
    setIsInputFocus(true)
    if (onFocus) {
      onFocus()
    }
  }

  const blurFunction = () => {
    setIsInputFocus(false)
    if (onBlur) {
      onBlur()
    }
  }

  const keepChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }
    setHasText(e.target.value)
  }

  return (
    <InputContainer customWidth={customWidth}>
      <InputTextField>
        <InputFieldInput
          fieldColor={fieldColor}
          placeholder={placeholder || ' '}
          min={min}
          type={type || 'text'}
          isLeadingIcon={!!leadingIcon}
          value={forceChangeValue || hasText}
          onFocus={focusFunction}
          customWidth={customWidth}
          onBlur={blurFunction}
          onChange={onChange ? (e) => keepChange(e) : undefined}
        />
        {!leadingIcon || (
          // @ts-ignore
          <InputLeadingIcon icon={leadingIcon} />
        )}
        <InputLabel
          isLeadingIcon={!!leadingIcon}
          isTrailingIcon={!!trailingIcon}
          fieldColor={fieldColor}
          isInputFocus={isInputFocus}
          isForceLabel={!!hasText}
        >
          {fieldLabel}
        </InputLabel>
        {
          // @ts-ignore
          !trailingIcon || <InputTrailingIcon icon={trailingIcon} />
        }
      </InputTextField>
    </InputContainer>
  )
}
